// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/timeline"
import { TIMESHEET_FIELD_VIEW_MODE } from "./index"

export type StorageWriter = (value: Slice.TimesheetFieldViewMode) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(TIMESHEET_FIELD_VIEW_MODE, value.toString())
}

export const persistTimesheetFieldViewMode = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setTimesheetFieldViewMode.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.timesheetFieldViewModePersisted()),
        catchError(_ => of(Actions.timesheetFieldViewModePersistFailed())),
      )),
    )

export default persistTimesheetFieldViewMode(persist)
